// DEPRECATED PAGE
/* eslint-disable eqeqeq */
import { useState, useEffect, useRef, createRef } from 'react';
import {
  useOutletContext,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import { useGlobalStore } from 'store/globalStore';
import './Videos.css';
import { Button } from '@mui/material';
import Modal from '../../components/common/Modal';
import videoStatus from '../../utils/videoStatusUtils';
import DataTableVideos from './DataTable';
import ModalTitle from '../../components/modals/ModalTitle';

import '@aws-amplify/ui-react/styles.css';
import SearchIcon from '@mui/icons-material/Search';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { TextField, Backdrop, CircularProgress } from '@mui/material';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { deprecatedApiInterceptor } from '../../App';
import { createVideo } from './Resources';
import { SubjectLayout } from 'layouts/SubjectLayout';
import * as moment from 'moment';

import { AsyncPaginate } from 'react-select-async-paginate';
import { useAppProviderStore } from 'store/appProviderCopyStore';
import { CRUD_STATES } from 'constants/app';
import videoTableVisibility from 'utils/videosTableVisibility';
import { useNotification } from 'hooks/useNotification';

function Videos() {
  const { setActiveStep, setCancelUpload } = useAppProviderStore();
  const [auth, setAuth] = useOutletContext();
  const { setNotify } = useNotification();
  const { showConfirmationButton } = useState(true);

  const { setEditItem, editItem } = useGlobalStore();

  const [totalItems, setTotalItems] = useState(); //total de resultados retornado pela consulta de usuários
  const [totalPages, setTotalPages] = useState(); //total de páginas que temos para exibir
  const [itemsPerPage, setItemsPerPage] = useState(); //exibicao da posicao de itens que está sendo exibido no footer da página
  const [itemsInitialPage, setItemsInitialPage] = useState(1);
  const [actualPage, setActualPage] = useState(1); //numero exibido indicando qual a pagina atual que ele está
  const [userItems, setUserItems] = useState([]); //resultado da consulta

  const [titleFiltered, setTitleFiltered] = useState('');
  const [userFiltered, setUserFiltered] = useState('');
  const [unitFiltered, setUnitFiltered] = useState('');
  const [channelFiltered, setChannelFiltered] = useState('');
  const [personalityFiltered, setPersonalityFiltered] = useState('');
  const [collectionFiltered, setCollectionFiltered] = useState('');
  const [keyFiltered, setKeyFiltered] = useState('');
  const [keyWordFiltered, setKeyWordFiltered] = useState('');

  const [filterApplied, setFilterApplied] = useState(false);

  const offSetItems = useRef(0);
  const unitRef = createRef();
  const personalityRef = createRef();
  const channelRef = createRef();

  const userRef = createRef();
  const keyWordRef = createRef();
  const inputTitleRef = createRef();
  const inputCollectionRef = createRef();
  const inputkeyWordRef = createRef();

  const [isLoading, setIsLoading] = useState(false);

  //FILTER'S STATES
  //VALUE OF UNITS AND CHANNELS
  const [selectedOption, setSelectedOption] = useState({});

  const [confirmDialogAction, setConfirmDialogAction] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
  });
  const [openTitle, setOpenTitle] = useState(false);

  const [pending, setPending] = useState();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const handleSelectedOptionChange = (selectId, selected) => {
    setSelectedOption(prevSelectedOptions => ({
      ...prevSelectedOptions,
      [selectId]: selected,
    }));
  };

  const [filterPath, setFilterPath] = useState(() => {
    if (searchParams) {
      let queryPath = '';
      if (searchParams.get('canal')) {
        let channel = JSON.parse(searchParams.get('canal'));
        handleSelectedOptionChange('channel', channel);
        queryPath += `&channelId=${channel.value}`;
      }
      if (searchParams.get('unidade')) {
        let unit = JSON.parse(searchParams.get('unidade'));
        handleSelectedOptionChange('unit', unit);
        queryPath += `&unitId=${unit.value}`;
      }
      return queryPath;
    } else {
      return undefined;
    }
  });

  useEffect(() => {
    setActiveStep(1);
    offSetItems.current = 0;
    setItemsInitialPage(1);
    if (editItem) {
      setPending(true);
      setTimeout(() => {
        videoDataTableGetItems();
      }, 4000);
    } else {
      videoDataTableGetItems();
    }
    setEditItem(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterPath]);

  const handleOpen = async action => {
    setOpenTitle(true);
    setCancelUpload(false);
  };

  const handleEditAndViewVideo = action => {
    setIsLoading(true);
    if (
      action.action === CRUD_STATES.EDIT &&
      (action.status === 'EXPIRED' || action.status === 'PUBLISHED')
    ) {
      const idToken = auth.getIdToken().getJwtToken();
      const apiName = 'admin';
      const path = `/admin/videos/${action?.id}/versions`;

      const data = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${idToken}`,
        },
      };
      deprecatedApiInterceptor
        .post(
          newToken => {
            setAuth(newToken);
          },
          apiName,
          path,
          data
        )
        .then(resp => {
          setIsLoading(false);
          navigate(`/upload-video/${action?.id}/${resp.version}`, {
            state: {
              action: action.action,
              id: action?.id,
              version: action?.version || 1,
            },
          });
        })
        .catch(error => {
          setIsLoading(false);
          setConfirmDialogAction({ isOpen: false });
          const errorJson = error.request.response;
          const parseJson = JSON.parse(errorJson);
          setNotify({
            isOpen: true,
            message: parseJson.message,
            type: 'error',
            title: 'Ops! Algo deu errado...',
          });
        });
    } else {
      setIsLoading(true);
      navigate(`/upload-video/${action?.id}/${action?.version}`, {
        state: {
          action: action.action,
          id: action.id,
          version: action?.version || 1,
        },
      });
    }
  };

  const handleArchiveVideo = async (videoId, version, title) => {
    setIsLoading(true);

    const idToken = auth.getIdToken().getJwtToken();
    const apiName = 'admin';
    const path = `/admin/videos/${videoId}/versions/${version}/status/archived`;

    const data = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${idToken}`,
      },
    };
    deprecatedApiInterceptor
      .patch(
        newToken => {
          setAuth(newToken);
        },
        apiName,
        path,
        data
      )
      .then(resp => {
        setTimeout(() => {
          setConfirmDialogAction({ isOpen: false });
          setNotify({
            isOpen: true,
            message: `O video "${title}" arquivado com sucesso!`,
            type: 'success',
            title: 'Sucesso!',
          });
          setIsLoading(false);
          videoDataTableGetItems();
        }, 4000);
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
        setConfirmDialogAction({ isOpen: false });
        const errorJson = error.request.response;
        const parseJson = JSON.parse(errorJson);
        setNotify({
          isOpen: true,
          message: parseJson.message,
          type: 'error',
          title: 'Ops! Algo deu errado...',
        });
      });
  };

  const handleRemoveVideo = async (videoId, version, title) => {
    setIsLoading(true);

    const idToken = auth.getIdToken().getJwtToken();
    const apiName = 'admin';
    const path = `/admin/videos/${videoId}/versions/${version}`;

    const data = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${idToken}`,
      },
    };
    deprecatedApiInterceptor
      .del(
        newToken => {
          setAuth(newToken);
        },
        apiName,
        path,
        data
      )
      .then(resp => {
        setTimeout(() => {
          setConfirmDialogAction({ isOpen: false });
          setNotify({
            isOpen: true,
            message: `O video "${title}" foi removido com sucesso!`,
            type: 'success',
            title: 'Sucesso!',
          });
          setIsLoading(false);
          videoDataTableGetItems();
        }, 4000);
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
        setConfirmDialogAction({ isOpen: false });
        const errorJson = error.request.response;
        const parseJson = JSON.parse(errorJson);
        setNotify({
          isOpen: true,
          message: parseJson.message,
          type: 'error',
          title: 'Ops! Algo deu errado...',
        });
      });
  };

  async function fetchDataAsync(url, newOffset) {
    return new Promise((resolve, reject) => {
      const session = auth;
      const idToken = session.getIdToken().getJwtToken();
      const apiName = 'admin';
      let path = url + newOffset;

      const data = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${idToken}`,
        },
      };
      deprecatedApiInterceptor
        .get(
          newToken => {
            setAuth(newToken);
          },
          apiName,
          path,
          data
        )
        .then(resp => {
          resolve(resp);
        })
        .catch(error => {
          console.log(error);
        });
    });
  }

  // const limitKeyWords = 10;
  const loadOptionsKeyWords = async (search, prevOptionsKeyWords) => {
    const newOffsetKeyWords = prevOptionsKeyWords.length;

    const usersUrl = '/admin/keywords?limit=10&sortBy=name&offset=';
    try {
      // Faça uma chamada à API com os parâmetros limit e offset
      const response = await fetchDataAsync(usersUrl, newOffsetKeyWords);
      const data = response.keywordList;
      const total = response.totalItemsCountFiltered;

      // Transforme a resposta da API no formato esperado pelo AsyncPaginate
      const options = data.map(keyword => ({
        label: keyword.key,
        value: keyword.id,
      }));

      return {
        options: options,
        hasMore: newOffsetKeyWords + options.length < total, // Verifique se há mais itens a serem carregados
      };
    } catch (error) {
      console.error('Erro ao buscar dados da API:', error);
      return { options: [], hasMore: false };
    }
  };

  // const limitUsers = 10;
  const loadOptionsUsers = async (search, prevOptionsUsers) => {
    const newOffsetUsers = prevOptionsUsers.length;

    const usersUrl = '/admin/users?limit=10&sortBy=name&offset=';
    try {
      // Faça uma chamada à API com os parâmetros limit e offset
      const response = await fetchDataAsync(usersUrl, newOffsetUsers);
      const data = response.userList;
      const total = response.totalItemsCountFiltered;

      // Transforme a resposta da API no formato esperado pelo AsyncPaginate
      const options = data.map(user => ({
        label: user.name,
        value: user.userId,
      }));

      return {
        options: options,
        hasMore: newOffsetUsers + options.length < total, // Verifique se há mais itens a serem carregados
      };
    } catch (error) {
      console.error('Erro ao buscar dados da API:', error);
      return { options: [], hasMore: false };
    }
  };

  // const limitPersonalities = 10;
  const loadOptionsPersonalities = async (search, prevOptionsPersonalities) => {
    const newOffsetPersonalities = prevOptionsPersonalities.length;

    const personalitiesUrl =
      '/admin/personalities?limit=10&sortBy=name&offset=';
    try {
      // Faça uma chamada à API com os parâmetros limit e offset
      const response = await fetchDataAsync(
        personalitiesUrl,
        newOffsetPersonalities
      );
      const data = response.personalityList;
      const total = response.totalItemsCountFiltered;

      // Transforme a resposta da API no formato esperado pelo AsyncPaginate
      const options = data.map(personality => ({
        label: personality.name,
        value: personality.id,
      }));

      return {
        options: options,
        hasMore: newOffsetPersonalities + options.length < total, // Verifique se há mais itens a serem carregados
      };
    } catch (error) {
      console.error('Erro ao buscar dados da API:', error);
      return { options: [], hasMore: false };
    }
  };

  // const limitUnits = 10;
  const loadOptionsUnits = async (search, prevOptionsUnits) => {
    const newOffsetUnits = prevOptionsUnits.length;

    const unitsUrl = '/admin/units?limit=10&sortBy=name&offset=';
    try {
      // Faça uma chamada à API com os parâmetros limit e offset
      const response = await fetchDataAsync(unitsUrl, newOffsetUnits);
      const data = response.unitList;
      const total = response.totalItemsCountFiltered;

      // Transforme a resposta da API no formato esperado pelo AsyncPaginate
      const options = data.map(unit => ({
        label: unit.name,
        value: unit.id,
      }));

      return {
        options: options,
        hasMore: newOffsetUnits + options.length < total, // Verifique se há mais itens a serem carregados
      };
    } catch (error) {
      console.error('Erro ao buscar dados da API:', error);
      return { options: [], hasMore: false };
    }
  };

  // const limitChannels = 10;
  const loadOptionsChannels = async (search, prevOptionsChannels) => {
    const newOffsetChannels = prevOptionsChannels.length;

    const channelsUrl = '/admin/channels?limit=10&sortBy=name&offset=';
    try {
      // Faça uma chamada à API com os parâmetros limit e offset
      const response = await fetchDataAsync(channelsUrl, newOffsetChannels);
      const data = response.channelList;
      const total = response.totalItemsCountFiltered;

      // Transforme a resposta da API no formato esperado pelo AsyncPaginate
      const options = data.map(channel => ({
        label: channel.name,
        value: channel.id,
      }));

      return {
        options: options,
        hasMore: newOffsetChannels + options.length < total, // Verifique se há mais itens a serem carregados
      };
    } catch (error) {
      console.error('Erro ao buscar dados da API:', error);
      return { options: [], hasMore: false };
    }
  };

  const columns = [
    {
      id: 1,
      name: 'Versão',
      width: '80px',
      center: 'true',
      cell: row => {
        let previousVersions = row?.previousVersions?.map(item => {
          return item?.status;
        });
        return (
          <div
            className={
              row.version === undefined
                ? 'datatable_prevent_click'
                : 'video_datatable_version'
            }
            style={{
              backgroundColor:
                row?.status === 'PUBLISHED' ||
                previousVersions?.includes('PUBLISHED')
                  ? '#98FB98'
                  : row?.status === 'DRAFT' &&
                      !previousVersions?.includes('PUBLISHED')
                    ? '#FFFF8F'
                    : (row?.status === 'FAILED' ||
                          row?.status === 'EXPIRED' ||
                          row?.status === 'FAILED_UPLOAD') &&
                        (!previousVersions?.includes('PUBLISHED') ||
                          !previousVersions?.includes('DRAFT'))
                      ? '#FF7F7F'
                      : '#D3D3D3',
            }}>
            {row.version === undefined ? '-' : row.version}
          </div>
        );
      },
    },
    {
      id: 2,
      name: '',
      width: '30px',
      center: 'true',
      cell: row => (
        <div
          className="user_datatable_pointer"
          onClick={() => {
            handleEditAndViewVideo({
              action: CRUD_STATES.VIEW,
              id: row.id,
              version: row.version,
              status: row.status,
            });
          }}>
          {row.status === 'DRAFT' ? (
            ''
          ) : row.status === 'FAILED' ? (
            ''
          ) : (
            <img
              src="/img/videosDataTable/eye.svg"
              alt="Visualizar"
              className="eye-icon"
              style={{ width: '25px', height: '25px' }}
            />
          )}
        </div>
      ),
    },
    {
      id: 3,
      name: '',
      width: '30px',
      center: 'true',
      cell: row => (
        <div
          className="user_datatable_pointer"
          onClick={() => {
            handleEditAndViewVideo({
              action: CRUD_STATES.EDIT,
              id: row.id,
              version: row.version,
              status: row.status,
            });
            // alert("Funcionalidade ainda não implementada!")
          }}>
          {row.status === 'ARCHIVED' ? (
            ''
          ) : row.status === 'TRANSCODING' ? (
            ''
          ) : (
            <img
              src="/img/videosDataTable/editpencil.svg"
              className="edit-icon"
              alt="Editar"
              style={{ width: '25px', height: '25px' }}
            />
          )}
        </div>
      ),
    },
    {
      id: 4,
      name: '',
      width: '30px',
      center: 'true',
      cell: row => (
        <div className="user_datatable_pointer">
          {row.status === 'ARCHIVED' ? (
            ''
          ) : row.status === 'TRANSCODING' ? (
            ''
          ) : row.status === 'DRAFT' ? (
            <img
              className="trash-icon"
              src="/img/videosDataTable/trash.svg"
              onClick={() =>
                setConfirmDialogAction({
                  isOpen: true,
                  title: (
                    <div className="modalTitleText">
                      Remover o título "{row.title}"?
                    </div>
                  ),
                  subTitle: (
                    <div className="modalBodyText">
                      Você está removendo o título "{row.title}"
                      permanentemente.
                    </div>
                  ),
                  children: (
                    <div className="modalRemoveItem">
                      <DeleteOutlineOutlinedIcon
                        color="error"
                        fontSize="12px"
                      />
                    </div>
                  ),
                  confirmTextButton: 'Remover',
                  color: 'error',
                  onConfirm: () => {
                    handleRemoveVideo(row.id, row.version, row.title);
                  },
                  showConfirmationButton: { showConfirmationButton },
                  closeTextButton: 'Cancelar',
                })
              }
              alt="Remover"
              style={{ width: '25px', height: '25px' }}
            />
          ) : row.status === 'FAILED' ? (
            <img
              className="trash-icon"
              src="/img/videosDataTable/trash.svg"
              onClick={() =>
                setConfirmDialogAction({
                  isOpen: true,
                  title: (
                    <div className="modalTitleText">
                      Remover o título "{row.title}"?
                    </div>
                  ),
                  subTitle: (
                    <div className="modalBodyText">
                      Você está removendo o título "{row.title}"
                      permanentemente.
                    </div>
                  ),
                  children: (
                    <div className="modalRemoveItem">
                      <DeleteOutlineOutlinedIcon
                        color="error"
                        fontSize="12px"
                      />
                    </div>
                  ),
                  confirmTextButton: 'Remover',
                  color: 'error',
                  onConfirm: () => {
                    handleRemoveVideo(row.id, row.version);
                  },
                  showConfirmationButton: { showConfirmationButton },
                  closeTextButton: 'Cancelar',
                })
              }
              alt="Arquivar"
              style={{ width: '25px', height: '25px' }}
            />
          ) : (
            <img
              className="archive-icon"
              src="/img/videosDataTable/archive.svg"
              onClick={() =>
                setConfirmDialogAction({
                  isOpen: true,
                  title: (
                    <div className="modalTitleText">
                      Arquivar o título "{row.title}"?
                    </div>
                  ),
                  subTitle: (
                    <div className="modalBodyText">
                      Você irá arquivar o título "{row.title}" permanentemente.
                    </div>
                  ),
                  children: (
                    <div className="modalResendSentEmail">
                      <InfoOutlinedIcon color="primary" fontSize="12px" />
                    </div>
                  ),
                  confirmTextButton: 'Arquivar',
                  color: 'primary',
                  onConfirm: () => {
                    handleArchiveVideo(row.id, row.version, row.title);
                  },
                  showConfirmationButton: { showConfirmationButton },
                  closeTextButton: 'Cancelar',
                })
              }
              alt="Arquivar"
              style={{ width: '25px', height: '25px' }}
            />
          )}
        </div>
      ),
    },
    {
      id: 5,
      name: 'Título',
      cell: row => (
        <div
          className={row.title === undefined ? 'datatable_prevent_click' : ''}>
          {row.title === undefined ? '-' : row.title}
        </div>
      ),
      width: '600px',
    },
    {
      id: 6,
      name: 'Status',
      center: 'true',
      cell: row => (
        <div
          className={row.status === undefined ? 'datatable_prevent_click' : ''}>
          {row.status === undefined ? '-' : videoStatus[row.status]}
        </div>
      ),
      width: '200px',
    },
    {
      id: 7,
      name: 'Visibilidade',
      center: 'true',
      cell: row => (
        <div
          className={
            row.visibility === undefined ? 'datatable_prevent_click' : ''
          }>
          {row.visibility === undefined
            ? '-'
            : videoTableVisibility[row.visibility]}
        </div>
      ),
      width: '200px',
    },
    {
      id: 8,
      name: 'Visualizações',
      center: 'true',
      cell: row => (
        <div
          className={
            row.totalViews === undefined ? 'datatable_prevent_click' : ''
          }>
          {row.totalViews === undefined ? '-' : row.totalViews}
        </div>
      ),
      width: '151px',
    },
    {
      id: 9,
      name: 'Crédito (Personalidade)',
      selector: row =>
        row.personalitiesCredits === undefined
          ? 'datatable_prevent_click'
          : row.personalitiesCredits.length === 0
            ? 'datatable_prevent_click'
            : row.personalitiesCredits.length,
      width: '287px',
      center: 'true',
      cell: row => (
        <div
          className={
            row.personalitiesCredits === undefined
              ? 'datatable_prevent_click'
              : row.personalitiesCredits.length === 0
                ? 'datatable_prevent_click'
                : 'user_datatable_cell_hyperlink'
          }
          onClick={() =>
            setConfirmDialogAction({
              isOpen: true,
              scroll: 'paper',
              title: (
                <span
                  style={{
                    fontSize: '14px',
                    opacity: '0.8',
                    fontWeight: '300',
                    color: '#000',
                  }}>
                  {' '}
                  O vídeo "{row.title}" está associado as seguintes
                  personalidades (Crédito):
                </span>
              ),
              subTitle: (
                <List sx={{ pt: 0 }}>
                  {row.personalitiesCredits.map(item => (
                    <ListItem
                      disableGutters
                      key={item}
                      className="listItemRoot">
                      <ListItemAvatar className="listItemAvatar">
                        <img
                          src="/img/navbar_cockpit/personalidade_icon.svg"
                          alt="Personalidades Associadas"
                          style={{ width: '18px', height: '23px' }}
                        />
                      </ListItemAvatar>
                      <ListItemText
                        primary={item.name}
                        className="listItemText"
                      />
                    </ListItem>
                  ))}
                </List>
              ),
              children: (
                <>
                  <span className="modalResendSentEmail">
                    <InfoOutlinedIcon color="primary" fontSize="12px" />
                  </span>
                  <span
                    style={{
                      marginTop: '15px',
                      paddingRight: 8,
                      fontSize: '17px',
                    }}>
                    Personalidades associadas ({row.personalitiesCredits.length}
                    ).{' '}
                  </span>
                </>
              ),
              closeTextButton: 'Fechar',
            })
          }>
          {row.personalitiesCredits === undefined
            ? '-'
            : row.personalitiesCredits.length === 0
              ? '-'
              : row.personalitiesCredits.length}
        </div>
      ),
    },
    {
      id: 10,
      name: 'Com Quem (Personalidade)',
      center: 'true',
      selector: row =>
        row.personalities === undefined
          ? 'datatable_prevent_click'
          : row.personalities.length === 0
            ? 'datatable_prevent_click'
            : row.personalities.length,
      width: '287px',
      cell: row => (
        <div
          className={
            row.personalities === undefined
              ? 'datatable_prevent_click'
              : row.personalities.length === 0
                ? 'datatable_prevent_click'
                : 'user_datatable_cell_hyperlink'
          }
          onClick={() =>
            setConfirmDialogAction({
              isOpen: true,
              scroll: 'paper',
              title: (
                <span
                  style={{
                    fontSize: '14px',
                    opacity: '0.8',
                    fontWeight: '300',
                    color: '#000',
                  }}>
                  {' '}
                  O vídeo "{row.title}" está associado as seguintes
                  personalidades (Com Quem?):
                </span>
              ),
              subTitle: (
                <List sx={{ pt: 0 }}>
                  {row.personalities.map(item => (
                    <ListItem
                      disableGutters
                      key={item}
                      className="listItemRoot">
                      <ListItemAvatar className="listItemAvatar">
                        <img
                          src="/img/navbar_cockpit/personalidade_icon.svg"
                          alt="Personalidades Associadas"
                          style={{ width: '18px', height: '23px' }}
                        />
                      </ListItemAvatar>
                      <ListItemText
                        primary={item.name}
                        className="listItemText"
                      />
                    </ListItem>
                  ))}
                </List>
              ),
              children: (
                <>
                  <span className="modalResendSentEmail">
                    <InfoOutlinedIcon color="primary" fontSize="12px" />
                  </span>
                  <span
                    style={{
                      marginTop: '15px',
                      paddingRight: 8,
                      fontSize: '17px',
                    }}>
                    Personalidades associadas ({row.personalities.length}).{' '}
                  </span>
                </>
              ),
              closeTextButton: 'Fechar',
            })
          }>
          {row.personalities === undefined
            ? '-'
            : row.personalities.length === 0
              ? '-'
              : row.personalities.length}
        </div>
      ),
    },
    {
      id: 11,
      name: 'Palavras-Chave',
      selector: row =>
        row.keywords === undefined
          ? 'datatable_prevent_click'
          : row.keywords.length === 0
            ? 'datatable_prevent_click'
            : row.keywords.length,
      width: '287px',
      center: 'true',
      cell: row => (
        <div
          className={
            row.keywords === undefined
              ? 'datatable_prevent_click'
              : row.keywords.length === 0
                ? 'datatable_prevent_click'
                : 'user_datatable_cell_hyperlink'
          }
          onClick={() =>
            setConfirmDialogAction({
              isOpen: true,
              scroll: 'paper',
              title: (
                <span
                  style={{
                    fontSize: '14px',
                    opacity: '0.8',
                    fontWeight: '300',
                    color: '#000',
                  }}>
                  {' '}
                  O vídeo "{row.title}" está associado as seguintes
                  palavras-chave:
                </span>
              ),
              subTitle: (
                <List sx={{ pt: 0 }}>
                  {row.keywords.map(item => (
                    <ListItem
                      disableGutters
                      key={item}
                      className="listItemRoot">
                      <ListItemAvatar className="listItemAvatar">
                        <img
                          src="/img/navbar_cockpit/palavras_chave_icon.svg"
                          alt="Unidades Associadas"
                          style={{ width: '23px', height: '28px' }}
                        />
                      </ListItemAvatar>
                      <ListItemText
                        primary={item.key}
                        secondary={'(' + item.value + ')'}
                        className="listItemTextKeyWords"
                      />
                    </ListItem>
                  ))}
                </List>
              ),
              children: (
                <>
                  <span className="modalResendSentEmail">
                    <InfoOutlinedIcon color="primary" fontSize="12px" />
                  </span>
                  <span
                    style={{
                      marginTop: '15px',
                      paddingRight: 8,
                      fontSize: '17px',
                    }}>
                    Palavras-Chave associadas ({row.keywords.length}).{' '}
                  </span>
                </>
              ),
              closeTextButton: 'Fechar',
            })
          }>
          {row.keywords === undefined
            ? '-'
            : row.keywords.length === 0
              ? '-'
              : row.keywords.length}
        </div>
      ),
    },
    {
      id: 12,
      name: 'Coleção',
      cell: row => (
        <div
          className={
            row.collections === undefined
              ? 'datatable_prevent_click'
              : row.collections.length === 0
                ? 'datatable_prevent_click'
                : 'user_datatable_collection_hyperlink'
          }
          onClick={() =>
            setConfirmDialogAction({
              isOpen: true,
              scroll: 'paper',
              title: (
                <span
                  style={{
                    fontSize: '14px',
                    opacity: '0.8',
                    fontWeight: '300',
                    color: '#000',
                  }}>
                  {' '}
                  O vídeo "{row.title}" está associado as seguintes coleções:
                </span>
              ),
              subTitle: (
                <List sx={{ pt: 0 }}>
                  {row.collections.map(item => (
                    <ListItem
                      disableGutters
                      key={item}
                      className="listItemRoot">
                      <ListItemAvatar className="listItemAvatar">
                        <img
                          src="/img/navbar_cockpit/colecoes_icon.svg"
                          alt="Coleções Associadas"
                          style={{ width: '23px', height: '28px' }}
                        />
                      </ListItemAvatar>
                      <ListItemText
                        primary={item.title}
                        className="listItemTextKeyWords"
                      />
                    </ListItem>
                  ))}
                </List>
              ),
              children: (
                <>
                  <span className="modalResendSentEmail">
                    <InfoOutlinedIcon color="primary" fontSize="12px" />
                  </span>
                  <span
                    style={{
                      marginTop: '15px',
                      paddingRight: 8,
                      fontSize: '17px',
                    }}>
                    Coleções associadas ({row.collections.length}).{' '}
                  </span>
                </>
              ),
              closeTextButton: 'Fechar',
            })
          }>
          {row.collections === undefined
            ? '-'
            : row.collections.length === 0
              ? '-'
              : row.collections.map((collections, index) => (
                  <span key={index} className="text_overflow_collection">
                    {collections.title}
                    {index < row.collections.length - 1 ? ',' : '.'}{' '}
                  </span>
                ))}
        </div>
      ),
      width: '287px',
    },
    {
      id: 13,
      name: 'Unidade',
      selector: row =>
        row.units === undefined
          ? 'datatable_prevent_click'
          : row.units.length === 0
            ? 'datatable_prevent_click'
            : row.units.length,
      width: '115px',
      center: 'true',
      cell: row => (
        <div
          className={
            row.units === undefined
              ? 'datatable_prevent_click'
              : row.units.length === 0
                ? 'datatable_prevent_click'
                : 'user_datatable_cell_hyperlink'
          }
          onClick={() =>
            setConfirmDialogAction({
              isOpen: true,
              scroll: 'paper',
              title: (
                <span
                  style={{
                    fontSize: '14px',
                    opacity: '0.8',
                    fontWeight: '300',
                    color: '#000',
                  }}>
                  {' '}
                  O vídeo "{row.title}" está associado as seguintes unidades:
                </span>
              ),
              subTitle: (
                <List sx={{ pt: 0 }}>
                  {row.units.map(item => (
                    <ListItem
                      disableGutters
                      key={item}
                      className="listItemRoot">
                      <ListItemAvatar className="listItemAvatar">
                        <img
                          src="/img/navbar_cockpit/unidades_sesc_icon.svg"
                          alt="Unidades Associadas"
                          style={{ width: '30px', height: '35px' }}
                        />
                      </ListItemAvatar>
                      <ListItemText
                        primary={item.name}
                        className="listItemText"
                      />
                    </ListItem>
                  ))}
                </List>
              ),
              children: (
                <>
                  <span className="modalResendSentEmail">
                    <InfoOutlinedIcon color="primary" fontSize="12px" />
                  </span>
                  <span
                    style={{
                      marginTop: '15px',
                      paddingRight: 8,
                      fontSize: '17px',
                    }}>
                    Unidades associadas ({row.units.length}).{' '}
                  </span>
                </>
              ),
              closeTextButton: 'Fechar',
            })
          }>
          {row.units === undefined
            ? '-'
            : row.units.length === 0
              ? '-'
              : row.units.length}
        </div>
      ),
    },
    {
      id: 14,
      name: 'Canal',
      selector: row =>
        row.channels === undefined
          ? 'datatable_prevent_click'
          : row.channels.length === 0
            ? 'datatable_prevent_click'
            : row.channels.length,
      width: '115px',
      center: 'true',
      cell: row => (
        <div
          className={
            row.channels === undefined
              ? 'datatable_prevent_click'
              : row.channels.length === 0
                ? 'datatable_prevent_click'
                : 'user_datatable_cell_hyperlink'
          }
          onClick={() =>
            setConfirmDialogAction({
              isOpen: true,
              scroll: 'paper',
              title: (
                <span
                  style={{
                    fontSize: '14px',
                    opacity: '0.8',
                    fontWeight: '300',
                    color: '#000',
                  }}>
                  {' '}
                  O vídeo "{row.title}" está associado aos seguintes canais:
                </span>
              ),
              subTitle: (
                <List sx={{ pt: 0 }}>
                  {row.channels.map(item => (
                    <ListItem
                      disableGutters
                      key={item}
                      className="listItemRoot">
                      <ListItemAvatar className="listItemAvatar">
                        <img
                          src="/img/navbar_cockpit/canais_sesc_icon.svg"
                          alt="Canais associados"
                          style={{ width: '20px', height: '25px' }}
                        />
                      </ListItemAvatar>
                      <ListItemText
                        primary={item.name}
                        className="listItemText"
                      />
                    </ListItem>
                  ))}
                </List>
              ),
              children: (
                <>
                  <span className="modalResendSentEmail">
                    <InfoOutlinedIcon color="primary" fontSize="12px" />
                  </span>
                  <span
                    style={{
                      marginTop: '15px',
                      paddingRight: 8,
                      fontSize: '17px',
                    }}>
                    Canais associados ({row.channels.length}).
                  </span>
                </>
              ),
              closeTextButton: 'Fechar',
            })
          }>
          {row.channels === undefined
            ? '-'
            : row.channels.length === 0
              ? '-'
              : row.channels.length}
        </div>
      ),
    },
    {
      id: 15,
      name: 'Editor',
      selector: row =>
        row.updatedBy === undefined
          ? ''
          : row.updatedBy.length === 0
            ? ''
            : row.updatedBy.length,
      width: '333px',
      center: 'true',
      cell: row => (
        <div
          className={
            row.updatedBy === undefined
              ? 'datatable_prevent_click'
              : row.updatedBy.length === 0
                ? 'datatable_prevent_click'
                : ''
          }>
          {row.updatedBy === undefined
            ? '-'
            : row.updatedBy.length === 0
              ? '-'
              : row.updatedBy.name}
        </div>
      ),
    },
    {
      id: 16,
      name: 'Última atualização',
      center: 'true',
      selector: row => moment(row.updatedAt).format('HH:mm DD/MM/YYYY'),
      cell: row => (
        <div
          className={
            row.updatedAt === undefined ? 'datatable_prevent_click' : ''
          }>
          {row.updatedAt === undefined
            ? '-'
            : moment(row.updatedAt).format('HH:mm DD/MM/YYYY')}
        </div>
      ),
      width: '192px',
    },
    {
      id: 17,
      name: 'Limite de Players',
      center: 'true',
      selector: row => (row.viewsLimit === undefined ? '' : row.viewsLimit),
      cell: row => (
        <div
          className={
            row.viewsLimit === undefined ? 'datatable_prevent_click' : ''
          }>
          {row.viewsLimit === undefined ? '-' : row.viewsLimit}
        </div>
      ),
      width: '287px',
    },
    {
      id: 18,
      name: 'Data limite de veiculação',
      center: 'true',
      selector: row =>
        row?.expiresIn ? moment(row.expiresIn).format('DD/MM/YYYY') : '',
      cell: row => (
        <div
          className={
            row.expiresIn === undefined || row.expiresIn === null
              ? 'datatable_prevent_click'
              : ''
          }>
          {row.expiresIn === undefined || row.expiresIn === null
            ? '-'
            : moment(row.expiresIn).format('DD/MM/YYYY')}
        </div>
      ),
      width: '232px',
    },
  ];

  const videoDataTablePagination = arrowDirection => {
    setPending(true);
    if (arrowDirection === 'right') {
      offSetItems.current += 10;
    } else if (arrowDirection === 'left') {
      offSetItems.current -= 10;
    }

    const idToken = auth.getIdToken().getJwtToken();
    const apiName = 'admin';
    const path =
      '/admin/videos?limit=10&sortBy=name&offset=' +
      offSetItems.current +
      filterPath;

    const datab = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${idToken}`,
      },
    };
    deprecatedApiInterceptor
      .get(
        newToken => {
          setAuth(newToken);
        },
        apiName,
        path,
        datab
      )
      .then(resp => {
        setTotalItems(resp.totalItemsCountFiltered);
        setUserItems(resp.videoList);

        if (arrowDirection === 'right') {
          setItemsInitialPage(itemsInitialPage + 10);
          setActualPage(actualPage + 1);
          setItemsPerPage(itemsPerPage + resp.videoList.length);
          setPending(false);
        } else if (arrowDirection === 'left') {
          setItemsPerPage(itemsPerPage - userItems.length);
          setItemsInitialPage(itemsInitialPage - 10);
          setActualPage(actualPage - 1);
          setPending(false);
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  // row.units.map((unit) => <span key={unit.unitId}>{unit.unitId}</span>),
  const applyFilter = () => {
    setFilterApplied(true);

    let channelPath =
      channelRef.current.props.value.value === 'all'
        ? ''
        : '&channelId=' + channelRef.current.props.value.value;
    setChannelFiltered(
      channelRef.current.props.value.value === 'all'
        ? ''
        : channelRef.current.props.value.label
    );

    let unitPath =
      unitRef.current.props.value.value === 'all'
        ? ''
        : '&unitId=' + unitRef.current.props.value.value;
    setUnitFiltered(
      unitRef.current.props.value.value === 'all'
        ? ''
        : unitRef.current.props.value.label
    );

    let personalityPath =
      personalityRef.current.props.value.value === 'all'
        ? ''
        : '&personalityId=' + personalityRef.current.props.value.value;
    setPersonalityFiltered(
      personalityRef.current.props.value.value === 'all'
        ? ''
        : personalityRef.current.props.value.label
    );

    let userPath =
      userRef.current.props.value.value === 'all'
        ? ''
        : '&user=' + userRef.current.props.value.value;
    setUserFiltered(
      userRef.current.props.value.value === 'all'
        ? ''
        : userRef.current.props.value.label
    );

    let keywordPath =
      keyWordRef.current.props.value.value === 'all'
        ? ''
        : '&keywordId=' + keyWordRef.current.props.value.label;
    setKeyFiltered(
      keyWordRef.current.props.value.value === 'all'
        ? ''
        : keyWordRef.current.props.value.label
    );

    let inputTitlePath = '';
    if (inputTitleRef.current.value !== '') {
      inputTitlePath += '&title=' + inputTitleRef.current.value;
      setTitleFiltered(inputTitleRef.current.value);
    } else {
      setTitleFiltered('');
    }

    let inputCollectionPath = '';
    if (inputCollectionRef.current.value !== '') {
      inputCollectionPath +=
        '&collection.title=' + inputCollectionRef.current.value;
      setCollectionFiltered(inputCollectionRef.current.value);
    } else {
      setCollectionFiltered('');
    }

    let inputkeyWordPath = '';
    if (inputkeyWordRef.current.value !== '') {
      inputkeyWordPath += '&keyword=' + inputkeyWordRef.current.value;
      setKeyWordFiltered(inputkeyWordRef.current.value);
    } else {
      setKeyWordFiltered('');
    }

    let path =
      inputTitlePath +
      userPath +
      channelPath +
      unitPath +
      personalityPath +
      keywordPath +
      inputkeyWordPath +
      inputCollectionPath;
    setFilterPath(path);
  };

  const removeFilter = () => {
    setFilterApplied(false);
    inputTitleRef.current.value = null;
    inputCollectionRef.current.value = null;
    inputkeyWordRef.current.value = null;
    setKeyWordFiltered('');
    setTitleFiltered('');
    setCollectionFiltered('');
    setSelectedOption({});
    setFilterPath('');
  };

  const videoDataTableGetItems = () => {
    setPending(true);
    const idToken = auth.getIdToken().getJwtToken();
    const apiName = 'admin';
    const path =
      '/admin/videos?limit=10&sortBy=name&offset=' +
      offSetItems.current +
      filterPath;
    const datab = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${idToken}`,
      },
    };

    deprecatedApiInterceptor
      .get(
        newToken => {
          setAuth(newToken);
        },
        apiName,
        path,
        datab
      )
      .then(resp => {
        setTotalItems(resp.totalItemsCountFiltered);
        setUserItems(resp.videoList);

        if (resp.videoList.length === 0) {
          setItemsInitialPage(0);
        }

        if (resp.totalItemsCountFiltered <= 10) {
          setItemsPerPage(resp.totalItemsCountFiltered);
          setTotalPages(1);
        } else {
          setItemsPerPage(resp.videoList.length);
          setTotalPages(Math.ceil(resp.totalItemsCountFiltered / 10));
        }
        setPending(false);
      })
      .catch(error => {
        console.log(error);
        setPending(false);
      });
  };

  const customStyles = {
    rows: {
      style: {
        minHeight: '50px',
      },
    },
    headCells: {
      style: {
        paddingLeft: '20px',
        fontSize: '14px',
        color: '#475467',
        fontWeight: '500',
        backgroundColor: 'var(--gray-50, #F9FAFB)',
        width: 'auto',
      },
    },
    cells: {
      style: {
        paddingLeft: '20px',
        fontSize: '14px',
        color: '#6F6B7D',
        // backgroundColor: "var(--gray-50, #F9FAFB)",
        width: 'auto',
      },
    },
  };

  const enterPresskey = event => {
    if (event.keyCode === 13) {
      applyFilter();
    }
  };

  const videoDataTableGetVersions = async videoId => {
    const idToken = auth.getIdToken().getJwtToken();
    const apiName = 'admin';
    const path = `/admin/videos/${videoId}/versions`;

    const datab = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${idToken}`,
      },
    };
    return deprecatedApiInterceptor
      .get(
        newToken => {
          setAuth(newToken);
        },
        apiName,
        path,
        datab
      )
      .then(resp => {
        return resp;
      })
      .catch(error => {
        console.log(error);
        return 'error';
      });
  };

  const ExpandedComponent = ({ data }) => {
    const [resultados, setResultados] = useState(null);

    useEffect(() => {
      const videoDataTableVersions = async () => {
        try {
          const user = await videoDataTableGetVersions(data.id);
          setResultados(user);
        } catch (error) {
          console.log(error);
        }
      };
      videoDataTableVersions();
    }, [data]);

    return resultados ? (
      resultados === 'error' ? (
        <div className="row_version_body">
          <div className="table-videos-row">
            <div className="video_version_line">
              <div className="video_version_right_line"></div>
            </div>
            <div className="video_version_line">
              <div className="video_version_bottom_line"></div>
            </div>
            <div className="video_version_dot"></div>
            Houve um problema ao buscar outras versões para o título:{' '}
            <div className="version_title_bold">{data.title}</div>.
          </div>
        </div>
      ) : resultados.itemsCount > 1 ? (
        resultados.versionList.map((version, index) => {
          if (version.version != data.version) {
            return (
              <div
                className="row_version_body"
                id={version.version}
                key={index}>
                <div className="table-videos-row">
                  <div className="video_version_line">
                    <div className="video_version_right_line"></div>
                  </div>
                  <div className="video_version_line">
                    <div className="video_version_bottom_line"></div>
                  </div>
                  <div className="video_version_dot"></div>

                  <div className="table-videos-col-version">
                    {version.version === undefined ? '-' : version.version}
                  </div>

                  <div
                    className={
                      version.status === 'DRAFT'
                        ? 'table-videos-col-icons_prevent'
                        : 'table-videos-col-icons'
                    }
                    onClick={() => {
                      handleEditAndViewVideo({
                        action: CRUD_STATES.VIEW,
                        id: version.id,
                        version: version.version,
                        status: version.status,
                      });
                    }}>
                    {version.status === 'DRAFT' ? (
                      ''
                    ) : version.status === 'FAILED' ? (
                      ''
                    ) : (
                      <img
                        className="eye-icon"
                        src="/img/videosDataTable/eye.svg"
                        alt="Logo"
                        style={{ width: '25px', height: '25px' }}
                      />
                    )}
                  </div>

                  <div
                    className={
                      version.status === 'ARCHIVED'
                        ? 'table-videos-col-icons-2_prevent'
                        : version.status === 'TRANSCODING'
                          ? 'table-videos-col-icons-2_prevent'
                          : 'table-videos-col-icons-2'
                    }
                    onClick={() => {
                      handleEditAndViewVideo({
                        action: CRUD_STATES.EDIT,
                        id: version.id,
                        version: version.version,
                        status: version.status,
                      });

                      // alert("Funcionalidade ainda não implementada!")
                    }}>
                    {version.status === 'ARCHIVED' ? (
                      ''
                    ) : version.status === 'TRANSCODING' ? (
                      ''
                    ) : (
                      <img
                        className="edit-icon"
                        src="/img/videosDataTable/editpencil.svg"
                        alt="Editar"
                        style={{ width: '25px', height: '25px' }}
                      />
                    )}
                  </div>

                  <div
                    className={
                      version.status === 'ARCHIVED'
                        ? 'table-videos-col-icons-4_prevent'
                        : version.status === 'TRANSCODING'
                          ? 'table-videos-col-icons-4_prevent'
                          : 'table-videos-col-icons-4'
                    }>
                    {version.status === 'ARCHIVED' ? (
                      ''
                    ) : version.status === 'TRANSCODING' ? (
                      ''
                    ) : version.status === 'DRAFT' ? (
                      <img
                        className="trash-icon"
                        src="/img/videosDataTable/trash.svg"
                        onClick={() =>
                          setConfirmDialogAction({
                            isOpen: true,
                            title: (
                              <div className="modalTitleText">
                                Remover o título "{version.title}"?
                              </div>
                            ),
                            subTitle: (
                              <div className="modalBodyText">
                                Você está removendo o título "{version.title}"
                                permanentemente.
                              </div>
                            ),
                            children: (
                              <div className="modalRemoveItem">
                                <DeleteOutlineOutlinedIcon
                                  color="error"
                                  fontSize="12px"
                                />
                              </div>
                            ),
                            confirmTextButton: 'Remover',
                            color: 'error',
                            onConfirm: () => {
                              handleRemoveVideo(version.id, version.version);
                            },
                            showConfirmationButton: { showConfirmationButton },
                            closeTextButton: 'Cancelar',
                          })
                        }
                        alt="Remover"
                        style={{ width: '25px', height: '25px' }}
                      />
                    ) : version.status === 'FAILED' ? (
                      <img
                        className="trash-icon"
                        src="/img/videosDataTable/trash.svg"
                        onClick={() =>
                          setConfirmDialogAction({
                            isOpen: true,
                            title: (
                              <div className="modalTitleText">
                                Remover o título "{version.title}"?
                              </div>
                            ),
                            subTitle: (
                              <div className="modalBodyText">
                                Você está removendo o título "{version.title}"
                                permanentemente.
                              </div>
                            ),
                            children: (
                              <div className="modalRemoveItem">
                                <DeleteOutlineOutlinedIcon
                                  color="error"
                                  fontSize="12px"
                                />
                              </div>
                            ),
                            confirmTextButton: 'Remover',
                            color: 'error',
                            onConfirm: () => {
                              handleRemoveVideo(version.id, version.version);
                            },
                            showConfirmationButton: { showConfirmationButton },
                            closeTextButton: 'Cancelar',
                          })
                        }
                        alt="Arquivar"
                        style={{ width: '25px', height: '25px' }}
                      />
                    ) : (
                      <img
                        className="archive-icon"
                        src="/img/videosDataTable/archive.svg"
                        onClick={() =>
                          setConfirmDialogAction({
                            isOpen: true,
                            title: (
                              <div className="modalTitleText">
                                Arquivar o título "{version.title}"?
                              </div>
                            ),
                            subTitle: (
                              <div className="modalBodyText">
                                Você irá arquivar o título "{version.title}"
                                permanentemente.
                              </div>
                            ),
                            children: (
                              <div className="modalResendSentEmail">
                                <InfoOutlinedIcon
                                  color="primary"
                                  fontSize="12px"
                                />
                              </div>
                            ),
                            confirmTextButton: 'Arquivar',
                            color: 'primary',
                            onConfirm: () => {
                              handleArchiveVideo(version.id, version.version);
                            },
                            showConfirmationButton: { showConfirmationButton },
                            closeTextButton: 'Cancelar',
                          })
                        }
                        alt="Arquivar"
                        style={{ width: '25px', height: '25px' }}
                      />
                    )}
                  </div>

                  <div className="table-videos-col-title">
                    {version.title === undefined ? '-' : version.title}
                  </div>

                  <div className="table-videos-col-status">
                    {version.status === undefined
                      ? '-'
                      : videoStatus[version.status]}
                  </div>

                  <div className="table-videos-col-status">
                    {version.status === undefined
                      ? '-'
                      : videoTableVisibility[version.visibility]}
                  </div>

                  <div className="table-videos-col-views">
                    {version.totalViews === undefined
                      ? '-'
                      : version.totalViews}
                  </div>

                  <div className="personalityC_margin">
                    <div
                      className={
                        version.personalitiesCredits === undefined
                          ? 'table-videos-col-personalityC_prevent'
                          : version.personalitiesCredits.length === 0
                            ? 'table-videos-col-personalityC_prevent'
                            : 'table-videos-col-personalityC'
                      }
                      onClick={() =>
                        setConfirmDialogAction({
                          isOpen: true,
                          scroll: 'paper',
                          title: (
                            <span
                              style={{
                                fontSize: '14px',
                                opacity: '0.8',
                                fontWeight: '300',
                                color: '#000',
                              }}>
                              {' '}
                              O vídeo "{version.title}" está associado as
                              seguintes personalidades (Crédito):
                            </span>
                          ),
                          subTitle: (
                            <List sx={{ pt: 0 }}>
                              {version.personalitiesCredits.map(item => (
                                <ListItem
                                  disableGutters
                                  key={item}
                                  className="listItemRoot">
                                  <ListItemAvatar className="listItemAvatar">
                                    <img
                                      src="/img/navbar_cockpit/personalidade_icon.svg"
                                      alt="Personalidades Associadas"
                                      style={{ width: '18px', height: '23px' }}
                                    />
                                  </ListItemAvatar>
                                  <ListItemText
                                    primary={item.name}
                                    className="listItemText"
                                  />
                                </ListItem>
                              ))}
                            </List>
                          ),
                          children: (
                            <>
                              <span className="modalResendSentEmail">
                                <InfoOutlinedIcon
                                  color="primary"
                                  fontSize="12px"
                                />
                              </span>
                              <span
                                style={{
                                  marginTop: '15px',
                                  paddingRight: 8,
                                  fontSize: '17px',
                                }}>
                                Personalidades associadas (
                                {version.personalitiesCredits.length}).{' '}
                              </span>
                            </>
                          ),
                          closeTextButton: 'Fechar',
                        })
                      }>
                      {version.personalitiesCredits === undefined
                        ? '-'
                        : version.personalitiesCredits.length === 0
                          ? '-'
                          : version.personalitiesCredits.length}
                    </div>
                  </div>

                  <div className="personalityW_margin">
                    <div
                      className={
                        version.personalities === undefined
                          ? 'table-videos-col-personalityW_prevent'
                          : version.personalities.length === 0
                            ? 'table-videos-col-personalityW_prevent'
                            : 'table-videos-col-personalityW'
                      }
                      onClick={() =>
                        setConfirmDialogAction({
                          isOpen: true,
                          scroll: 'paper',
                          title: (
                            <span
                              style={{
                                fontSize: '14px',
                                opacity: '0.8',
                                fontWeight: '300',
                                color: '#000',
                              }}>
                              {' '}
                              O vídeo "{version.title}" está associado as
                              seguintes personalidades (Com Quem?):
                            </span>
                          ),
                          subTitle: (
                            <List sx={{ pt: 0 }}>
                              {version.personalities.map(item => (
                                <ListItem
                                  disableGutters
                                  key={item}
                                  className="listItemRoot">
                                  <ListItemAvatar className="listItemAvatar">
                                    <img
                                      src="/img/navbar_cockpit/personalidade_icon.svg"
                                      alt="Personalidades Associadas"
                                      style={{ width: '18px', height: '23px' }}
                                    />
                                  </ListItemAvatar>
                                  <ListItemText
                                    primary={item.name}
                                    className="listItemText"
                                  />
                                </ListItem>
                              ))}
                            </List>
                          ),
                          children: (
                            <>
                              <span className="modalResendSentEmail">
                                <InfoOutlinedIcon
                                  color="primary"
                                  fontSize="12px"
                                />
                              </span>
                              <span
                                style={{
                                  marginTop: '15px',
                                  paddingRight: 8,
                                  fontSize: '17px',
                                }}>
                                Personalidades associadas (
                                {version.personalities.length}).{' '}
                              </span>
                            </>
                          ),
                          closeTextButton: 'Fechar',
                        })
                      }>
                      {version.personalities === undefined
                        ? '-'
                        : version.personalities.length === 0
                          ? '-'
                          : version.personalities.length}
                    </div>
                  </div>

                  <div className="keyword_margin">
                    <div
                      className={
                        version.keywords === undefined
                          ? 'table-videos-col-keyWord_prevent'
                          : version.keywords.length === 0
                            ? 'table-videos-col-keyWord_prevent'
                            : 'table-videos-col-keyWord'
                      }
                      onClick={() =>
                        setConfirmDialogAction({
                          isOpen: true,
                          scroll: 'paper',
                          title: (
                            <span
                              style={{
                                fontSize: '14px',
                                opacity: '0.8',
                                fontWeight: '300',
                                color: '#000',
                              }}>
                              {' '}
                              O vídeo "{version.title}" está associado as
                              seguintes palavras-chave:
                            </span>
                          ),
                          subTitle: (
                            <List sx={{ pt: 0 }}>
                              {version.keywords.map(item => (
                                <ListItem
                                  disableGutters
                                  key={item}
                                  className="listItemRoot">
                                  <ListItemAvatar className="listItemAvatar">
                                    <img
                                      src="/img/navbar_cockpit/palavras_chave_icon.svg"
                                      alt="Unidades Associadas"
                                      style={{ width: '23px', height: '28px' }}
                                    />
                                  </ListItemAvatar>
                                  <ListItemText
                                    primary={item.key}
                                    secondary={'(' + item.value + ')'}
                                    className="listItemTextKeyWords"
                                  />
                                </ListItem>
                              ))}
                            </List>
                          ),
                          children: (
                            <>
                              <span className="modalResendSentEmail">
                                <InfoOutlinedIcon
                                  color="primary"
                                  fontSize="12px"
                                />
                              </span>
                              <span
                                style={{
                                  marginTop: '15px',
                                  paddingRight: 8,
                                  fontSize: '17px',
                                }}>
                                Palavras-Chave associadas (
                                {version.keywords.length}).{' '}
                              </span>
                            </>
                          ),
                          closeTextButton: 'Fechar',
                        })
                      }>
                      {version.keywords === undefined
                        ? '-'
                        : version.keywords.length === 0
                          ? '-'
                          : version.keywords.length}
                    </div>
                  </div>

                  <div className="collection_margin">
                    <div
                      className={
                        version.collections === undefined
                          ? 'table-videos-col-collection_prevent'
                          : version.keywords.length === 0
                            ? 'table-videos-col-collection_prevent'
                            : 'table-videos-col-collection'
                      }
                      onClick={() =>
                        setConfirmDialogAction({
                          isOpen: true,
                          scroll: 'paper',
                          title: (
                            <span
                              style={{
                                fontSize: '14px',
                                opacity: '0.8',
                                fontWeight: '300',
                                color: '#000',
                              }}>
                              {' '}
                              O vídeo "{version.title}" está associado as
                              seguintes coleções:
                            </span>
                          ),
                          subTitle: (
                            <List sx={{ pt: 0 }}>
                              {version.collections.map(item => (
                                <ListItem
                                  disableGutters
                                  key={item}
                                  className="listItemRoot">
                                  <ListItemAvatar className="listItemAvatar">
                                    <img
                                      src="/img/navbar_cockpit/colecoes_icon.svg"
                                      alt="Coleções Associadas"
                                      style={{ width: '23px', height: '28px' }}
                                    />
                                  </ListItemAvatar>
                                  <ListItemText
                                    primary={item.title}
                                    className="listItemTextKeyWords"
                                  />
                                </ListItem>
                              ))}
                            </List>
                          ),
                          children: (
                            <>
                              <span className="modalResendSentEmail">
                                <InfoOutlinedIcon
                                  color="primary"
                                  fontSize="12px"
                                />
                              </span>
                              <span
                                style={{
                                  marginTop: '15px',
                                  paddingRight: 8,
                                  fontSize: '17px',
                                }}>
                                Coleções associadas (
                                {version.collections.length}).{' '}
                              </span>
                            </>
                          ),
                          closeTextButton: 'Fechar',
                        })
                      }>
                      {version.collections === undefined
                        ? '-'
                        : version.collections.length === 0
                          ? '-'
                          : version.collections.map((collections, index) => (
                              <span
                                key={index}
                                className="text_overflow_collection">
                                {collections.title}
                                {index < version.collections.length - 1
                                  ? ','
                                  : '.'}{' '}
                              </span>
                            ))}
                    </div>
                  </div>

                  <div className="units_margin">
                    <div
                      className={
                        version.units === undefined
                          ? 'table-videos-col-units_prevent'
                          : version.units.length === 0
                            ? 'table-videos-col-units_prevent'
                            : 'table-videos-col-units'
                      }
                      onClick={() =>
                        setConfirmDialogAction({
                          isOpen: true,
                          scroll: 'paper',
                          title: (
                            <span
                              style={{
                                fontSize: '14px',
                                opacity: '0.8',
                                fontWeight: '300',
                                color: '#000',
                              }}>
                              {' '}
                              O vídeo "{version.title}" está associado as
                              seguintes unidades:
                            </span>
                          ),
                          subTitle: (
                            <List sx={{ pt: 0 }}>
                              {version.units.map(item => (
                                <ListItem
                                  disableGutters
                                  key={item}
                                  className="listItemRoot">
                                  <ListItemAvatar className="listItemAvatar">
                                    <img
                                      src="/img/navbar_cockpit/unidades_sesc_icon.svg"
                                      alt="Unidades Associadas"
                                      style={{ width: '30px', height: '35px' }}
                                    />
                                  </ListItemAvatar>
                                  <ListItemText
                                    primary={item.name}
                                    className="listItemText"
                                  />
                                </ListItem>
                              ))}
                            </List>
                          ),
                          children: (
                            <>
                              <span className="modalResendSentEmail">
                                <InfoOutlinedIcon
                                  color="primary"
                                  fontSize="12px"
                                />
                              </span>
                              <span
                                style={{
                                  marginTop: '15px',
                                  paddingRight: 8,
                                  fontSize: '17px',
                                }}>
                                Unidades associadas ({version.units.length}).{' '}
                              </span>
                            </>
                          ),
                          closeTextButton: 'Fechar',
                        })
                      }>
                      {version.units === undefined
                        ? '-'
                        : version.units.length === 0
                          ? '-'
                          : version.units.length}
                    </div>
                  </div>

                  <div className="channels_margin">
                    <div
                      className={
                        version.channels === undefined
                          ? 'table-videos-col-channels_prevent'
                          : version.channels.length === 0
                            ? 'table-videos-col-channels_prevent'
                            : 'table-videos-col-channels'
                      }
                      onClick={() =>
                        setConfirmDialogAction({
                          isOpen: true,
                          scroll: 'paper',
                          title: (
                            <span
                              style={{
                                fontSize: '14px',
                                opacity: '0.8',
                                fontWeight: '300',
                                color: '#000',
                              }}>
                              {' '}
                              O vídeo "{version.title}" está associado aos
                              seguintes canais:
                            </span>
                          ),
                          subTitle: (
                            <List sx={{ pt: 0 }}>
                              {version.channels.map(item => (
                                <ListItem
                                  disableGutters
                                  key={item}
                                  className="listItemRoot">
                                  <ListItemAvatar className="listItemAvatar">
                                    <img
                                      src="/img/navbar_cockpit/canais_sesc_icon.svg"
                                      alt="Canais associados"
                                      style={{ width: '20px', height: '25px' }}
                                    />
                                  </ListItemAvatar>
                                  <ListItemText
                                    primary={item.name}
                                    className="listItemText"
                                  />
                                </ListItem>
                              ))}
                            </List>
                          ),
                          children: (
                            <>
                              <span className="modalResendSentEmail">
                                <InfoOutlinedIcon
                                  color="primary"
                                  fontSize="12px"
                                />
                              </span>
                              <span
                                style={{
                                  marginTop: '15px',
                                  paddingRight: 8,
                                  fontSize: '17px',
                                }}>
                                Canais associados ({version.channels.length}).
                              </span>
                            </>
                          ),
                          closeTextButton: 'Fechar',
                        })
                      }>
                      {version.channels === undefined
                        ? '-'
                        : version.channels.length === 0
                          ? '-'
                          : version.channels.length}
                    </div>
                  </div>

                  <div className="table-videos-col-editor">
                    {version.updatedBy === undefined
                      ? '-'
                      : version.updatedBy.length === 0
                        ? '-'
                        : version.updatedBy.name}
                  </div>

                  <div className="table-videos-col-lastAtt">
                    {version.updatedAt === undefined
                      ? '-'
                      : moment(version.updatedAt).format('HH:mm DD/MM/YYYY')}
                  </div>

                  <div className="table-videos-col-viewsLimit">
                    {version.viewsLimit === undefined
                      ? '-'
                      : version.viewsLimit}
                  </div>

                  <div className="table-videos-col-expiresIn">
                    {version.expiresIn === undefined
                      ? '-'
                      : moment(version.expiresIn).format('DD/MM/YYYY')}
                  </div>
                </div>
              </div>
            );
          }
          return null;
        })
      ) : (
        <div className="row_version_body">
          <div className="versions_not_found">
            <div className="video_version_line">
              <div className="video_version_right_line"></div>
            </div>
            <div className="video_version_line">
              <div className="video_version_bottom_line"></div>
            </div>
            <div className="video_version_dot"></div>
            Não foram encontradas outras versões para o título:{' '}
            <div className="version_title_bold">{data.title}</div>.
          </div>
        </div>
      )
    ) : (
      <div className="row_version_body">
        <div className="table-videos-row row_notcontent_margin">
          Carregando...
        </div>
      </div>
    );
  };

  return (
    <SubjectLayout.Root id="main-videos">
      <Backdrop
        open={isLoading}
        style={{ zIndex: 9999 }}
        sx={{ color: '#fff' }}>
        <CircularProgress color="inherit" size={60} />
      </Backdrop>
      <SubjectLayout.Title>Vídeos</SubjectLayout.Title>
      <SubjectLayout.IconButton
        onClick={() => {
          handleOpen({ action: CRUD_STATES.CREATE, id: '' });
        }}>
        Vídeo
      </SubjectLayout.IconButton>
      <SubjectLayout.InnerContainer>
        <div className="datatable_content">
          <div className="user_data_table_title">
            <p>Listagem de Vídeos </p>
            <div
              style={{
                display: 'flex',
                border: '1px solid #1462A5',
                padding: 12,
              }}>
              <span
                className="table-videos-col-version"
                style={{
                  backgroundColor: '#98FB98',
                  marginLeft: 10,
                  marginRight: 10,
                }}></span>{' '}
              <span style={{ fontSize: 12 }}>
                Existe um video com status Publicado
              </span>
              <span
                className="table-videos-col-version"
                style={{
                  backgroundColor: '#FFFF8F',
                  marginLeft: 10,
                  marginRight: 10,
                }}></span>{' '}
              <span style={{ fontSize: 12 }}>
                Não existe vídeo com status Publicado, existe um Rascunho
              </span>
              <span
                className="table-videos-col-version"
                style={{
                  backgroundColor: '#FF7F7F',
                  marginLeft: 10,
                  marginRight: 10,
                }}></span>{' '}
              <span style={{ fontSize: 12 }}>
                Não existe vídeo com status Publicado ou Rascunho, existe um
                vídeo com status Expirado ou Erro de transcodificação
              </span>
            </div>
          </div>
          <div className="flex-filter">
            <div>
              <div className="user_datatable_filter_title">Filtros</div>
              <section id="user_container">
                <div className="user_datatable_filter filter_input">
                  <TextField
                    inputProps={{
                      style: {
                        height: '21px',
                        width: '110px',
                      },
                    }}
                    sx={{
                      '& .MuiFormLabel-root': {
                        color: '#B7B5BE',
                        fontSize: '15px',
                      },
                      // '& label.Mui-focused': { color: '#6e6d6d' },
                      '& .MuiInputBase-input': {
                        backgroundColor:
                          'var(--light-solid-color-extra-card-background, #FFF)',
                      },
                      '& .MuiOutlinedInput-root': {
                        // '& fieldset': { border: '1px solid var(--light-solid-color-extra-divider, #DBDADE)', borderRadius: '6px' },
                        // '&:hover fieldset': { borderColor: '#1361A4' }
                      },
                    }}
                    label={
                      <div style={{ display: 'inline-block' }}>
                        <SearchIcon fontSize="small" />
                        Título
                      </div>
                    }
                    placeholder="Título"
                    id="outlined-size-small"
                    defaultValue=""
                    size="small"
                    inputRef={inputTitleRef}
                    onKeyDown={e => enterPresskey(e)}
                    // onChange={evt => {
                    //   setTitleFiltered(evt.target.value)
                    // }}
                  />
                </div>

                <div className="user_datatable_filter ">
                  <AsyncPaginate
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        '&:hover': {
                          borderColor: '#464646',
                        },
                        borderRadius: '5px',
                        width: 'auto',
                      }),
                      singleValue: base => ({
                        ...base,
                        // padding: 5,
                        borderRadius: 6,
                        color: '#B7B5BE',
                        fontSize: '15px',
                        display: 'flex',
                      }),
                    }}
                    theme={theme => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        primary25: '#e9e9ea',
                        primary: '#0A6CCF',
                        width: 'auto',
                      },
                    })}
                    noOptionsMessage={() => 'Nada encontrado'}
                    loadingMessage={() => 'Carregando...'}
                    menuPosition="fixed"
                    loadOptions={loadOptionsUsers}
                    onBlurResetsInput={false}
                    onCloseResetsInput={false}
                    className="basic-single"
                    classNamePrefix="select"
                    isSearchable={false}
                    isClearable={true}
                    selectRef={userRef}
                    name="color"
                    autoload={true}
                    defaultValue={{ value: 'all', label: 'Editor' }}
                    value={
                      selectedOption.user
                        ? selectedOption.user
                        : { value: 'all', label: 'Editor' }
                    }
                    onChange={selected => {
                      handleSelectedOptionChange('user', selected);
                    }}
                    onKeyDown={e => enterPresskey(e)}
                  />
                </div>

                <div className="user_datatable_filter ">
                  <AsyncPaginate
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        '&:hover': {
                          borderColor: '#464646',
                        },
                        borderRadius: '5px',
                        width: 'auto',
                      }),
                      singleValue: base => ({
                        ...base,
                        // padding: 5,
                        borderRadius: 6,
                        color: '#B7B5BE',
                        fontSize: '15px',
                        display: 'flex',
                      }),
                    }}
                    theme={theme => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        primary25: '#e9e9ea',
                        primary: '#0A6CCF',
                        width: 'auto',
                      },
                    })}
                    noOptionsMessage={() => 'Nada encontrado'}
                    loadingMessage={() => 'Carregando...'}
                    menuPosition="fixed"
                    loadOptions={loadOptionsUnits}
                    onBlurResetsInput={false}
                    onCloseResetsInput={false}
                    className="basic-single"
                    classNamePrefix="select"
                    isSearchable={false}
                    isClearable={true}
                    selectRef={unitRef}
                    name="color"
                    autoload={true}
                    defaultValue={{ value: 'all', label: 'Unidade' }}
                    value={
                      selectedOption.unit
                        ? selectedOption.unit
                        : { value: 'all', label: 'Unidade' }
                    }
                    onChange={selected => {
                      handleSelectedOptionChange('unit', selected);
                    }}
                    onKeyDown={e => enterPresskey(e)}
                  />
                </div>

                <div className="user_datatable_filter ">
                  <AsyncPaginate
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        '&:hover': {
                          borderColor: '#464646',
                        },
                        borderRadius: '5px',
                        width: 'auto',
                      }),
                      singleValue: base => ({
                        ...base,
                        // padding: 5,
                        borderRadius: 6,
                        color: '#B7B5BE',
                        fontSize: '15px',
                        display: 'flex',
                      }),
                    }}
                    theme={theme => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        primary25: '#e9e9ea',
                        primary: '#0A6CCF',
                        width: 'auto',
                      },
                    })}
                    noOptionsMessage={() => 'Nada encontrado'}
                    loadingMessage={() => 'Carregando...'}
                    menuPosition="fixed"
                    loadOptions={loadOptionsChannels}
                    onBlurResetsInput={false}
                    onCloseResetsInput={false}
                    className="basic-single"
                    classNamePrefix="select"
                    isSearchable={false}
                    isClearable={true}
                    selectRef={channelRef}
                    name="color"
                    autoload={true}
                    defaultValue={{ value: 'all', label: 'Canal' }}
                    value={
                      selectedOption.channel
                        ? selectedOption.channel
                        : { value: 'all', label: 'Canal' }
                    }
                    onChange={selected => {
                      handleSelectedOptionChange('channel', selected);
                    }}
                    onKeyDown={e => enterPresskey(e)}
                  />
                </div>

                <div className="user_datatable_filter ">
                  <AsyncPaginate
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        '&:hover': {
                          borderColor: '#464646',
                        },
                        borderRadius: '5px',
                        width: 'auto',
                      }),
                      singleValue: base => ({
                        ...base,
                        // padding: 5,
                        borderRadius: 6,
                        color: '#B7B5BE',
                        fontSize: '15px',
                        display: 'flex',
                      }),
                    }}
                    theme={theme => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        primary25: '#e9e9ea',
                        primary: '#0A6CCF',
                        width: 'auto',
                      },
                    })}
                    noOptionsMessage={() => 'Nada encontrado'}
                    loadingMessage={() => 'Carregando...'}
                    menuPosition="fixed"
                    loadOptions={loadOptionsPersonalities}
                    onBlurResetsInput={false}
                    onCloseResetsInput={false}
                    className="basic-single"
                    classNamePrefix="select"
                    isSearchable={false}
                    isClearable={true}
                    selectRef={personalityRef}
                    name="color"
                    autoload={true}
                    defaultValue={{ value: 'all', label: 'Personalidades' }}
                    value={
                      selectedOption.personality
                        ? selectedOption.personality
                        : { value: 'all', label: 'Personalidade' }
                    }
                    onChange={selected => {
                      handleSelectedOptionChange('personality', selected);
                    }}
                    onKeyDown={e => enterPresskey(e)}
                  />
                </div>

                <div className="user_datatable_filter filter_input">
                  <TextField
                    inputProps={{
                      style: {
                        height: '21px',
                        width: '110px',
                      },
                    }}
                    sx={{
                      '& .MuiFormLabel-root': {
                        color: '#B7B5BE',
                        fontSize: '15px',
                      },
                      // '& label.Mui-focused': { color: '#6e6d6d' },
                      '& .MuiInputBase-input': {
                        backgroundColor:
                          'var(--light-solid-color-extra-card-background, #FFF)',
                      },
                      '& .MuiOutlinedInput-root': {
                        // '& fieldset': { border: '1px solid var(--light-solid-color-extra-divider, #DBDADE)', borderRadius: '6px' },
                        // '&:hover fieldset': { borderColor: '#1361A4' }
                      },
                    }}
                    label={
                      <div style={{ display: 'inline-block' }}>
                        <SearchIcon fontSize="small" />
                        Coleção
                      </div>
                    }
                    id="outlined-size-small"
                    defaultValue=""
                    size="small"
                    inputRef={inputCollectionRef}
                    placeholder="Coleção"
                    onKeyDown={e => enterPresskey(e)}
                    onChange={evt => {
                      setCollectionFiltered(evt.target.value);
                    }}
                  />
                </div>

                <div className="user_datatable_filter ">
                  <AsyncPaginate
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        '&:hover': {
                          borderColor: '#464646',
                        },
                        borderRadius: '5px',
                        width: 'auto',
                      }),
                      singleValue: base => ({
                        ...base,
                        // padding: 5,
                        borderRadius: 6,
                        color: '#B7B5BE',
                        fontSize: '15px',
                        display: 'flex',
                      }),
                    }}
                    theme={theme => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        primary25: '#e9e9ea',
                        primary: '#0A6CCF',
                        width: 'auto',
                      },
                    })}
                    noOptionsMessage={() => 'Nada encontrado'}
                    loadingMessage={() => 'Carregando...'}
                    menuPosition="fixed"
                    loadOptions={loadOptionsKeyWords}
                    onBlurResetsInput={false}
                    onCloseResetsInput={false}
                    className="basic-single"
                    classNamePrefix="select"
                    isSearchable={false}
                    isClearable={true}
                    selectRef={keyWordRef}
                    name="color"
                    autoload={true}
                    defaultValue={{ value: 'all', label: 'Chave' }}
                    value={
                      selectedOption.keyword
                        ? selectedOption.keyword
                        : { value: 'all', label: 'Chave' }
                    }
                    onChange={selected => {
                      handleSelectedOptionChange('keyword', selected);
                    }}
                    onKeyDown={e => enterPresskey(e)}
                    // isDisabled={true}
                  />
                </div>

                <div className="user_datatable_filter filter_input">
                  <TextField
                    inputProps={{
                      style: {
                        height: '21px',
                        width: '120px',
                      },
                    }}
                    sx={{
                      '& .MuiFormLabel-root': {
                        color: '#B7B5BE',
                        fontSize: '15px',
                      },
                      '& .MuiInputBase-input': {
                        backgroundColor:
                          'var(--light-solid-color-extra-card-background, #FFF)',
                      },
                      '& .MuiOutlinedInput-root': {
                        // '& fieldset': { border: '1px solid var(--light-solid-color-extra-divider, #DBDADE)', borderRadius: '6px' },
                        // '&:hover fieldset': { borderColor: '#1361A4' }
                      },
                    }}
                    label={
                      <div style={{ display: 'inline-block' }}>
                        <SearchIcon fontSize="small" />
                        Palavra-Chave
                      </div>
                    }
                    // disabled={true}
                    id="outlined-size-small"
                    defaultValue=""
                    size="small"
                    placeholder="Palavra-Chave"
                    inputRef={inputkeyWordRef}
                    onKeyDown={e => enterPresskey(e)}
                    // onChange={evt => {
                    //   setKeyWordFiltered(evt.target.value)
                    // }}
                  />
                </div>

                <div className="user_datatable_filter ">
                  <Button
                    sx={{
                      width: 'auto',
                      height: 'auto',
                      borderRadius: '8px',
                      color: '#1361A4',
                      border: '1px solid #D7E8F7',
                      background: 'var(--base-white, #FFF)',
                      boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
                      textTransform: 'capitalize',
                      fontSize: '16px',
                      fontStyle: 'normal',
                      fontWeight: '500',
                      lineHeight: '24px',
                    }}
                    onClick={applyFilter}
                    variant="outlined"
                    startIcon={<SearchIcon />}
                    id="video-apply-filter">
                    Aplicar Filtro
                  </Button>
                </div>
              </section>

              <section id="user_container">
                <div
                  className={
                    filterApplied === true &&
                    titleFiltered !== undefined &&
                    titleFiltered !== null &&
                    titleFiltered !== ''
                      ? 'user_datatable_filtered_values'
                      : ''
                  }>
                  {filterApplied === true ? (
                    titleFiltered === undefined ? (
                      ''
                    ) : titleFiltered === '' ? (
                      ''
                    ) : titleFiltered === null ? (
                      ''
                    ) : (
                      <div className="filtered_content_main">
                        <div className="filtered_content_title">Título: </div>
                        <div className="filtered_content_content">
                          {titleFiltered}
                        </div>
                      </div>
                    )
                  ) : null}
                </div>

                <div
                  className={
                    filterApplied === true &&
                    userFiltered !== undefined &&
                    userFiltered !== null &&
                    userFiltered !== ''
                      ? 'user_datatable_filtered_values'
                      : ''
                  }>
                  {filterApplied === true ? (
                    userFiltered === undefined ? (
                      ''
                    ) : userFiltered === '' ? (
                      ''
                    ) : userFiltered === null ? (
                      ''
                    ) : (
                      <div className="filtered_content_main">
                        <div className="filtered_content_title">Editor: </div>
                        <div className="filtered_content_content">
                          {userFiltered}
                        </div>
                      </div>
                    )
                  ) : null}
                </div>

                <div
                  className={
                    filterApplied === true &&
                    unitFiltered !== undefined &&
                    unitFiltered !== null &&
                    unitFiltered !== ''
                      ? 'user_datatable_filtered_values'
                      : ''
                  }>
                  {filterApplied === true ? (
                    unitFiltered === undefined ? (
                      ''
                    ) : unitFiltered === '' ? (
                      ''
                    ) : unitFiltered === null ? (
                      ''
                    ) : (
                      <div className="filtered_content_main">
                        <div className="filtered_content_title">Unidade: </div>
                        <div className="filtered_content_content">
                          {unitFiltered}
                        </div>
                      </div>
                    )
                  ) : null}
                </div>

                <div
                  className={
                    filterApplied === true &&
                    channelFiltered !== undefined &&
                    channelFiltered !== null &&
                    channelFiltered !== ''
                      ? 'user_datatable_filtered_values'
                      : ''
                  }>
                  {filterApplied === true ? (
                    channelFiltered === undefined ? (
                      ''
                    ) : channelFiltered === '' ? (
                      ''
                    ) : channelFiltered === null ? (
                      ''
                    ) : (
                      <div className="filtered_content_main">
                        <div className="filtered_content_title">Canal: </div>
                        <div className="filtered_content_content">
                          {channelFiltered}
                        </div>
                      </div>
                    )
                  ) : null}
                </div>

                <div
                  className={
                    filterApplied === true &&
                    personalityFiltered !== undefined &&
                    personalityFiltered !== null &&
                    personalityFiltered !== ''
                      ? 'user_datatable_filtered_values'
                      : ''
                  }>
                  {filterApplied === true ? (
                    personalityFiltered === undefined ? (
                      ''
                    ) : personalityFiltered === '' ? (
                      ''
                    ) : personalityFiltered === null ? (
                      ''
                    ) : (
                      <div className="filtered_content_main">
                        <div className="filtered_content_title">
                          Personalidade:{' '}
                        </div>
                        <div className="filtered_content_content">
                          {personalityFiltered}
                        </div>
                      </div>
                    )
                  ) : null}
                </div>

                <div
                  className={
                    filterApplied === true &&
                    collectionFiltered !== undefined &&
                    collectionFiltered !== null &&
                    collectionFiltered !== ''
                      ? 'user_datatable_filtered_values'
                      : ''
                  }>
                  {filterApplied === true ? (
                    collectionFiltered === undefined ? (
                      ''
                    ) : collectionFiltered === '' ? (
                      ''
                    ) : collectionFiltered === null ? (
                      ''
                    ) : (
                      <div className="filtered_content_main">
                        <div className="filtered_content_title">Coleção: </div>
                        <div className="filtered_content_content">
                          {collectionFiltered}
                        </div>
                      </div>
                    )
                  ) : null}
                </div>

                <div
                  className={
                    filterApplied === true &&
                    keyFiltered !== undefined &&
                    keyFiltered !== null &&
                    keyFiltered !== ''
                      ? 'user_datatable_filtered_values'
                      : ''
                  }>
                  {filterApplied === true ? (
                    keyFiltered === undefined ? (
                      ''
                    ) : keyFiltered === '' ? (
                      ''
                    ) : keyFiltered === null ? (
                      ''
                    ) : (
                      <div className="filtered_content_main">
                        <div className="filtered_content_title">Chave: </div>
                        <div className="filtered_content_content">
                          {keyFiltered}
                        </div>
                      </div>
                    )
                  ) : null}
                </div>

                <div
                  className={
                    filterApplied === true &&
                    keyWordFiltered !== undefined &&
                    keyWordFiltered !== null &&
                    keyWordFiltered !== ''
                      ? 'user_datatable_filtered_values'
                      : ''
                  }>
                  {filterApplied === true ? (
                    keyWordFiltered === undefined ? (
                      ''
                    ) : keyWordFiltered === '' ? (
                      ''
                    ) : keyWordFiltered === null ? (
                      ''
                    ) : (
                      <div className="filtered_content_main">
                        <div className="filtered_content_title">
                          Palavra-Chave:{' '}
                        </div>
                        <div className="filtered_content_content">
                          {keyWordFiltered}
                        </div>
                      </div>
                    )
                  ) : null}
                </div>
                {filterApplied === true &&
                  (titleFiltered !== '' ||
                    userFiltered !== '' ||
                    unitFiltered !== '' ||
                    channelFiltered !== '' ||
                    personalityFiltered !== '' ||
                    collectionFiltered !== '' ||
                    keyFiltered !== '' ||
                    keyWordFiltered !== '') && (
                    <div
                      className="user_datatable_clean_filter"
                      onClick={removeFilter}
                      id="video-clear-filter">
                      Limpar Filtros
                    </div>
                  )}
              </section>
            </div>
          </div>
          <div></div>
          <div className="user_datatable_width">
            <DataTableVideos
              fixedHeader={false}
              columns={columns}
              expandableRows={true}
              userItems={userItems}
              customStyles={customStyles}
              pending={pending}
              ExpandedComponent={ExpandedComponent}
              handleEditAndViewVideo={handleEditAndViewVideo}
              handleRemoveVideo={handleRemoveVideo}
              handleArchiveVideo={handleArchiveVideo}
              videoDataTableGetVersions={videoDataTableGetVersions}
              videoStatus={videoStatus}
              videoTableVisibility={videoTableVisibility}
              confirmDialogAction={confirmDialogAction}
              setConfirmDialogAction={setConfirmDialogAction}
              showConfirmationButton={showConfirmationButton}
            />
          </div>
          <div className="user_data_table_footer">
            <div className="user_data_table_footer_total">
              {itemsInitialPage} - {itemsPerPage} de {totalItems}
            </div>
            <div className="user_data_table_footer_pages">
              <KeyboardArrowLeftIcon
                className={
                  actualPage == 1
                    ? 'user_datatable_disabled_left_arrow'
                    : 'user_datatable_left_arrow'
                }
                onClick={() => videoDataTablePagination('left')}
              />
              {actualPage}
              <KeyboardArrowRightIcon
                className={
                  totalItems <= 10
                    ? 'user_datatable_disabled_right_arrow'
                    : actualPage === totalPages
                      ? 'user_datatable_disabled_right_arrow'
                      : 'user_datatable_right_arrow'
                }
                onClick={() => videoDataTablePagination('right')}
              />
            </div>
          </div>
        </div>
      </SubjectLayout.InnerContainer>
      <Modal
        confirmDialogAction={confirmDialogAction}
        setConfirmDialogAction={setConfirmDialogAction}
      />
      <ModalTitle
        open={openTitle}
        createVideo={createVideo}
        onClose={() => setOpenTitle(false)}
        CRUD_STATES={CRUD_STATES}
        setAuth={setAuth}
        auth={auth}
      />
    </SubjectLayout.Root>
  );
}

export default Videos;
